/**
 * This function returns an array of trackSids filtered by trackStatus
 * @param tracks A Map containing trackSids and trackStatuses
 * @param status The trackStatus to filter for
 * @return An array of trackSids
 */

interface PresenterTrackProps {
  kind: 'audio' | 'video'
  status: string
}

export default function (tracks: Map<string, PresenterTrackProps> = new Map(), status: string): string[] {

  return [ ...tracks ]
    .filter(([, props]) => status === props.status)
    .map(([trackSid]) => trackSid)

}
